import React from 'react'

import { Box, Typography } from '@mui/material'


export default function createdColumn() {

	return [ {
		name: 'timestampCreate',
		label: 'Creation Date',
		options: {
			display: 'excluded',
			filterType: 'textField',
			customBodyRowRender: value => value,
		},
	}, {
		name: 'timestampCreate',
		label: 'Creation Date',
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box
				sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<Typography variant="body1">{value}</Typography>
			</Box>,
		},
	} ]
}